import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// 모바일 기기 감지 함수
const isMobileDevice = () => {
  // 화면 크기로 체크
  const isMobileWidth = window.innerWidth <= 767;

  // userAgent로 체크
  const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
  const isMobileUserAgent = mobileRegex.test(navigator.userAgent);

  // 터치 이벤트 지원 여부로 체크
  const hasTouchSupport = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

  // 종합적으로 판단
  return isMobileWidth || isMobileUserAgent || (hasTouchSupport && window.innerWidth < 1024);
};

// iOS Safari 100vh 문제 해결을 위한 동적 뷰포트 높이 계산
const setMobileViewportHeight = () => {
  // 실제 뷰포트 높이를 CSS 변수로 설정
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
  document.documentElement.style.setProperty('--mobile-vh', `${window.innerHeight}px`);
};

// Safe Area 색상 동적 설정 함수
const setSafeAreaColor = (colorName = 'white') => {
  // 색상 이름을 직접 사용하여 하드코딩 방지
  const color = colorName;
  
  // meta theme-color 태그 업데이트
  const metaThemeColor = document.querySelector('meta[name="theme-color"]');
  if (metaThemeColor) {
    metaThemeColor.setAttribute('content', color);
  }
  
  // CSS 변수 업데이트 (런타임에서 safe area 색상 변경)
  document.documentElement.style.setProperty('--safe-area-color', color);
  
  // CSS에서 사용할 수 있도록 before 요소의 배경색도 업데이트
  const style = document.createElement('style');
  style.textContent = `
    @media (max-width: 767px) {
      html::before {
        background-color: ${color} !important;
      }
    }
  `;
  
  // 기존 safe-area-style이 있으면 제거
  const existingStyle = document.getElementById('safe-area-style');
  if (existingStyle) {
    existingStyle.remove();
  }
  
  style.id = 'safe-area-style';
  document.head.appendChild(style);
};

// 전역 함수로 등록 (개발자 도구에서 사용 가능)
window.setSafeAreaColor = setSafeAreaColor;

// iOS 기기 감지
const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

if (isIOS || isSafari || isMobileDevice()) {
  // 초기 설정
  setMobileViewportHeight();
  setSafeAreaColor('white'); // 네비게이션바 색상과 동일하게 설정 (흰색)
  
  // 리사이즈 이벤트에 디바운스 적용
  let resizeTimer;
  const handleResize = () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      setMobileViewportHeight();
    }, 100);
  };
  
  // 이벤트 리스너 등록
  window.addEventListener('resize', handleResize);
  window.addEventListener('orientationchange', () => {
    // 오리엔테이션 변경 시 약간의 지연 후 재계산
    setTimeout(setMobileViewportHeight, 200);
  });
  
  // iOS Safari에서 스크롤 시 주소창 변화 감지
  if (isIOS && isSafari) {
    window.addEventListener('scroll', handleResize, { passive: true });
    
    // 터치 이벤트로도 감지 (더 정확한 반응)
    let touchTimer;
    window.addEventListener('touchend', () => {
      clearTimeout(touchTimer);
      touchTimer = setTimeout(setMobileViewportHeight, 300);
    }, { passive: true });
  }
  
  // iOS 기기임을 body에 클래스로 표시
  if (isIOS) {
    document.body.classList.add('ios');
  }
}
